module.exports = __webpack_public_path__ + "img/IT0000103338052.a57fd237.png";